import styled from 'styled-components'
import { CustomerButton } from '@bm-js/atlascloud-ui'
import { Icon } from '@bm-js/atlascloud-ui'
import { DynamicContentType, LucideIconName } from '@bm-js/atlascloud-shared'
import { DocumentData } from '@bm-js/atlascloud-shared'

const StyledDocumentContent = styled.div`
  .document-button-inner {
    display: flex;
    align-items: center;
    svg {
      width: 20px;
      height: 20px;
      margin-left: 0.5rem;
    }
  }
`

type Props = {
  content: DynamicContentType<DocumentData>
}

const DocumentContent = ({ content }: Props) => {
  return (
    <StyledDocumentContent
      style={{
        marginBottom: content.data.marginBottom,
      }}
    >
      <CustomerButton>
        <span className='document-button-inner'>
          {content.data.text}
          <Icon name={LucideIconName.FileText} />
        </span>
      </CustomerButton>
    </StyledDocumentContent>
  )
}

export default DocumentContent
